export function defaultContactDenomination (application) {
  const slug = String(application?.app?.slug || application?.slug || '').toLowerCase().trim()
  return slug === 'tract' ? 'Syndicat' : 'CSE'
}

export function resolveContactDenomination (domain, application) {
  const raw = String(domain?.contact?.denomination || '').trim()
  if (raw) {
    return raw
  }

  return defaultContactDenomination(application)
}
